import styled from 'styled-components'

export const NodeChartWrapper = styled.div``
